import React, { useState } from 'react'
import { Card, Button, Input, Avatar, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import AllComments from './commentCard'
import {
  removeDiscussion,
  addComment
} from '../../../reducers/discussionReducer'
import './../styles.css'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const { Meta } = Card
const { confirm } = Modal

const DiscussionCard = ({ discussion, user }) => {
  const dispatch = useDispatch()
  const [commText, setcommText] = useState('')

  const onPost = () => {
    if (commText !== '') {
      dispatch(addComment(discussion._id, commText, user))
      setcommText('')
    } else console.log('cant post empty comment')
  }

  const deleteDiscussion = (discussionId) => {
    confirm({
      title: 'Are you sure you want to delete this discussion?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        dispatch(removeDiscussion(discussionId))
      },
      onCancel() {
        return
      }
    })
  }

  const onTxtChange = (txt) => {
    setcommText(txt.target.value)
  }

  return (
    <div className="container">
      <Card
        hoverable
        className="customcard"
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Meta
              avatar={<Avatar src={user?.photo} />}
              title={user?.name}
            />
            {discussion?.user?._id === user?._id && (
              <Button
                disabled={!(discussion?.user?._id === user?._id)}
                className="deleteButton"
                onClick={() => deleteDiscussion(discussion._id)}
              >
                Delete
              </Button>
            )}
          </div>
        }
      >
        <div className="dis">{discussion.data}</div>
        <Card
          size="small"
          type="inner"
          className="commentcard"
          title="Comments"
        >
          <AllComments
            comments={discussion.comments}
            dId={discussion._id}
            Luser={user}
          />
        </Card>
        <div className="container">
          <Input
            size="large"
            allowClear={true}
            value={commText}
            bordered={true}
            placeholder="Type your comment here"
            onChange={onTxtChange}
            className="txt"
          ></Input>
          <Button onClick={onPost}>Add Comment</Button>
        </div>
      </Card>
    </div>
  )
}

export default DiscussionCard
